
import { mapActions, mapState } from "vuex";
import dialogCloseBtn from "../common/dialog-close-btn.vue";

export default {
  components: { dialogCloseBtn },
  data() {
    return {
      stage: 0,
      availablePrintersLoading: false,
      availablePrinters: [],
      loading: false,
      selectedPrinter: ""
    };
  },
  props: {
    dialog: false,
    availableUnusedPrinters: {
      default: []
    }
  },
  async mounted() {
    this.availablePrinters = JSON.parse(
      JSON.stringify(this.availableUnusedPrinters)
    );
    this.availablePrintersLoading = true;
    try {
      await this.getLocationPrinters({
        id: this.locationDetails.id,
        forceFetch: false
      });
    } catch (error) {
      this.$nuxt.$emit("show-error-toast", error);
    }
    this.availablePrintersLoading = false;
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    isValid() {
      return this.selectedPrinter !== "";
    }
  },
  methods: {
    ...mapActions("restaurant", ["getLocationPrinters", "addNewKotPrinter"]),

    handlePrinterSelected(val) {
      this.selectedPrinter = val;
    },
    async handleAddPrinter() {
      this.loading = true;
      let payload = this.availablePrinters[this.selectedPrinter];
      delete payload.selected;

      try {
        const { data } = await this.addNewKotPrinter({ printer: payload });
        await this.getLocationPrinters({
          id: this.locationDetails.id,
          forceFetch: true
        });
        this.$nuxt.$emit("show-toast", {
          text: "Printer added successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.$emit("printerAdded", [data.printer?.id]);
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.loading = false;
    }
  }
};
